export default {
    cn: {
        dayTradeReport: {
            CloseDateText: '平仓日期：',
            pointText: '点值：',
            ownTimeText: '持仓时间(分钟)：',
            profitText: '盈利额(以上)：',
            downloadName: '短线平仓及盈利单报告',
            loginText: '账号：',
            ibNumText: '代理账号：',
            symbolText: '产品：',
            regionText: '地区编号：',
            securityText: '产品组：',
            to: '至',
            startTime: '开始时间',
            endTime: '结束时间',
            tableHead: [
                { key: 'Ticket', value: '单号', upper: false },
                { key: 'Login', value: '账号', upper: false },
                { key: 'NAME', value: '客户', upper: false },
                { key: 'C_GROUP', value: '组别', upper: false },
                { key: 'CURRENCY', value: '入金货币', upper: false },
                { key: 'AGENT_ACCOUNT', value: '代理账号' },
                // { key: 'IB_NAME', value: '代理姓名' },
                { key: 'OID', value: '办事处号码' },
                { key: 'OFFICE_NAME', value: '所属办事处' },
                { key: 'RID', value: '地区编号' },
                { key: 'ACC_NAME', value: '所属地区' },
                { key: 'Symbol', value: '产品', upper: false },
                { key: 'TYPE', value: '产品组' },
                { key: 'Volume', value: '手数', upper: false },
                { key: 'Cmd', value: '买/卖', upper: false },
                { key: 'Open_Date', value: '开仓日期', upper: false },
                { key: 'Open_Time', value: '开仓时间', upper: false },
                { key: 'Open_Price', value: '开仓价', upper: false },
                { key: 'Close_Date', value: '平仓日期', upper: false },
                { key: 'Close_Time', value: '平仓时间', upper: false },
                { key: 'Close_Price', value: '平仓价', upper: false },
                { key: 'Commission', value: '客户佣金', upper: false },
                { key: 'Swaps', value: '利息', upper: false },
                { key: 'Profit', value: '平仓盈亏', upper: false },
                { key: 'Minutes', value: '持仓时间(分)', upper: false },
                { key: 'PointVal', value: '点值', upper: false },
                { key: 'TOTAL_PL_MONTHLY', value: '今月平仓盈亏' },
                { key: 'TOTAL_CLOSE_PL', value: '开户至今平仓盈亏' },
                { key: 'TOTAL_FLOATING_PL', value: '开户至今未平仓盈亏' },
                { key: 'TOTAL_PL', value: '开户至今盈亏' },
            ]
        }
    },
    hk: {
        dayTradeReport: {
            CloseDateText: '平倉日期：',
            pointText: '點值：',
            ownTimeText: '持倉時間(分鐘)：',
            profitText: '盈利額(以上)：',
            downloadName: '短線平倉及盈利單報告',
            loginText: '賬號：',
            ibNumText: '代理賬號：',
            symbolText: '產品：',
            regionText: '地區編號：',
            securityText: '產品組：',
            to: '至',
            startTime: '開始時間',
            endTime: '結束時間',
            tableHead: [
                { key: 'Ticket', value: '單號', upper: false },
                { key: 'Login', value: '賬號', upper: false },
                { key: 'NAME', value: '客戶', upper: false },
                { key: 'C_GROUP', value: '組別', upper: false },
                { key: 'CURRENCY', value: '入金貨幣', upper: false },
                { key: 'AGENT_ACCOUNT', value: '代理張號' },
                // { key: 'IB_NAME', value: '代理姓名' },
                { key: 'OID', value: '辦事處號碼' },
                { key: 'OFFICE_NAME', value: '所屬辦事處' },
                { key: 'RID', value: '地區編號' },
                { key: 'ACC_NAME', value: '所屬地區' },
                { key: 'Symbol', value: '產品', upper: false },
                { key: 'TYPE', value: '產品組' },
                { key: 'Volume', value: '手數', upper: false },
                { key: 'Cmd', value: '買/賣', upper: false },
                { key: 'Open_Date', value: '開倉日期', upper: false },
                { key: 'Open_Time', value: '開倉時間', upper: false },
                { key: 'Open_Price', value: '開倉價', upper: false },
                { key: 'Close_Date', value: '平倉日期', upper: false },
                { key: 'Close_Time', value: '平倉時間', upper: false },
                { key: 'Close_Price', value: '平倉價', upper: false },
                { key: 'Commission', value: '客戶佣金', upper: false },
                { key: 'Swaps', value: '利息', upper: false },
                { key: 'Profit', value: '平倉盈虧', upper: false },
                { key: 'Minutes', value: '持倉時間(分)', upper: false },
                { key: 'PointVal', value: '點值', upper: false },
                { key: 'TOTAL_PL_MONTHLY', value: '今月平倉盈虧' },
                { key: 'TOTAL_CLOSE_PL', value: '開戶至今平倉盈虧' },
                { key: 'TOTAL_FLOATING_PL', value: '開戶至今未平倉盈虧' },
                { key: 'TOTAL_PL', value: '開戶至今盈虧' },
            ]
        }
    },
    en: {
        dayTradeReport: {
            CloseDateText: 'Close Date：',
            pointText: 'Point Value(Above)：',
            ownTimeText: 'Hold Time(Minutes)：',
            profitText: 'Profit：',
            downloadName: 'Short Term Close Position And Profit Gain Report',
            loginText: 'login：',
            ibNumText: 'IB Account：',
            symbolText: 'Symbol：',
            regionText: 'Region ID：',
            securityText: 'Securities：',
            to: 'to',
            startTime: 'Start Time',
            endTime: 'End Time',
            tableHead: [
                { key: 'Ticket', value: 'Ticket', upper: false },
                { key: 'Login', value: 'Login', upper: false },
                { key: 'NAME', value: 'Client Name', upper: false },
                { key: 'C_GROUP', value: 'Group', upper: false },
                { key: 'CURRENCY', value: 'Currency', upper: false },
                { key: 'AGENT_ACCOUNT', value: 'IB Account' },
                // { key: 'IB_NAME', value: 'IB Name' },
                { key: 'OID', value: 'Office ID' },
                { key: 'OFFICE_NAME', value: 'Office Name' },
                { key: 'RID', value: 'Region ID' },
                { key: 'ACC_NAME', value: 'Region Name' },
                { key: 'Symbol', value: 'Symbol', upper: false },
                { key: 'TYPE', value: 'Security' },
                { key: 'Volume', value: 'Volume', upper: false },
                { key: 'Cmd', value: 'Buy/Sell', upper: false },
                { key: 'Open_Date', value: 'Open Date', upper: false },
                { key: 'Open_Time', value: 'Open Time', upper: false },
                { key: 'Open_Price', value: 'Open Price', upper: false },
                { key: 'Close_Date', value: 'Close Date', upper: false },
                { key: 'Close_Time', value: 'Close Time', upper: false },
                { key: 'Close_Price', value: 'Close Price', upper: false },
                { key: 'Commission', value: 'Commission', upper: false },
                { key: 'Swaps', value: 'Swaps', upper: false },
                { key: 'Profit', value: 'Profit', upper: false },
                { key: 'Minutes', value: 'Hold Time(Minutes)', upper: false },
                { key: 'PointVal', value: 'Point Value', upper: false },
                { key: 'TOTAL_PL_MONTHLY', value: 'Total PL Monthly' },
                { key: 'TOTAL_CLOSE_PL', value: 'Total Close PL' },
                { key: 'TOTAL_FLOATING_PL', value: 'Total Floating PL' },
                { key: 'TOTAL_PL', value: 'Total PL' },
            ]
        }
    }
}


// WEBPACK FOOTER //
// ./src/language/report/dayTradeReport.js